/**
 * Fiche technique visuelle — bandeau signature (3 mots) + infos pratiques
 * réutilise directement quiz-vigneron-data.json (même source que le quiz)
 */

(function () {
  const ICONS = {
    thermometer: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 14.76V3.5a2 2 0 0 0-4 0v11.26a4 4 0 1 0 4 0Z"/></svg>',
    grape: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="14" r="2.5"/><circle cx="14" cy="14" r="2.5"/><circle cx="11" cy="18.5" r="2.5"/><circle cx="8" cy="9.5" r="2.5"/><circle cx="14" cy="9.5" r="2.5"/><path d="M11 5V3"/></svg>',
    hourglass: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3h12M6 21h12M7 3c0 4 5 6 5 9s-5 5-5 9M17 3c0 4-5 6-5 9s5 5 5 9"/></svg>',
    leaf: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 21c9 0 14-5 14-14V4h-3C7 4 3 9 3 16v5"/><path d="M5 21c0-5 3-9 7-11"/></svg>',
    cocktail: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16l-7 9v7h3M9 20h3M10 13 4 4"/></svg>',
    pin: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s7-6.5 7-12a7 7 0 0 0-14 0c0 5.5 7 12 7 12Z"/><circle cx="12" cy="9" r="2.4"/></svg>'
  };

  async function init() {
    const root = document.querySelector("[data-fiche-technique]");
    if (!root) return;

    const dataUrl = root.dataset.dataUrl;
    const productTitle = (root.dataset.productTitle || "").trim();

    try {
      const res = await fetch(dataUrl);
      const json = await res.json();
      const vin = (json.vins || []).find(
        (v) => (v.shopify_title || "").trim() === productTitle
      );
      if (!vin) {
        root.classList.add("ft-hidden");
        return;
      }
      render(root, vin);
    } catch (e) {
      root.classList.add("ft-hidden");
    }
  }

  function render(root, vin) {
    const words = (vin.trois_mots || [])
      .map((w) => `<span class="ft-word">${w}</span>`)
      .join("");

    const cepageText = (vin.cepages || [])
      .map((c) => `${c.pourcentage}% ${c.cepage}`)
      .join(", ");

    const facts = [];
    if (vin.appellation) {
      facts.push(fact(ICONS.pin, "Appellation", vin.appellation));
    }
    if (vin.service && vin.service.temperature) {
      facts.push(fact(ICONS.thermometer, "Service", vin.service.temperature));
    }
    if (cepageText) {
      facts.push(fact(ICONS.grape, "Cépages", cepageText));
    }
    if (vin.service && vin.service.garde) {
      facts.push(fact(ICONS.hourglass, "Garde", vin.service.garde));
    }

    const badges = [];
    if (vin.bio) badges.push(badge(ICONS.leaf, "Agriculture biologique"));
    if (vin.vin_cocktail) badges.push(badge(ICONS.cocktail, "Vin cocktail"));
    if (vin.garde_longue) badges.push(badge(ICONS.hourglass, "Vin de garde"));

    root.innerHTML = `
      ${words ? `<div class="ft-words">${words}</div>` : ""}
      <div class="ft-facts">${facts.join("")}</div>
      ${badges.length ? `<div class="ft-badges">${badges.join("")}</div>` : ""}
    `;
  }

  function fact(icon, label, value) {
    return `<div class="ft-fact">${icon}<span><span class="ft-fact-label">${label} :</span> ${value}</span></div>`;
  }

  function badge(icon, label) {
    return `<span class="ft-badge">${icon}${label}</span>`;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();